import {IAttributes, IAugmentedJQuery, IDirective, IModule, IScope, ITimeoutService} from "angular";
import {regNavn} from "../../felles/tjenester/tredjepartsTjenestenavn";
import {WebNavigasjon} from "../tjenester/WebNavigasjon";
import {scrollTilBunn} from "../../felles/stoettefunk/scroll";


export function registrerFlashVedNavigasjonforhindretDirective(angular: IModule) {
    angular.directive('flashVedNavigasjonforhindret', flashVedNavigasjonforhindretForInjisering())
}

function flashVedNavigasjonforhindretForInjisering() {
    return [regNavn.ng.$timeout, flashVedNavigasjonforhindret]
}

export function flashVedNavigasjonforhindret($timeout: ITimeoutService): IDirective {
    return {
        restrict: 'A',
        link: function ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes) {
            $scope.$on(WebNavigasjon.eventer.navigasjonForhindret, () => navigasjonForhindret());

            let pågåendeFlash = null;

            function navigasjonForhindret() {
                if (pågåendeFlash) return
                scrollTil();
                $element.addClass('std-flash')
                pågåendeFlash = $timeout(() => flash(), 1000);
            }

            function flash() {
                $element.removeClass('std-flash')
                pågåendeFlash = null;
            }

            function scrollTil() {
                scrollTilBunn($element);
            }

        }
    };
}
